import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";
import { TextItem } from "../../../LinksList";

export const StyledItem = styled(Type)`
  ${(props) => (!props["data-islink"] ? "text-decoration: none" : "")}
`;

export const StyledTextContent = styled(TextItem)`
  font-size: ${({ theme }) => theme.font.size.md};
  padding: 0;
`;
